import loadFolderForest from 'owa-mail-folder-forest-actions/lib/actions/loadFolderForest';
import { loadDefaultTable } from 'owa-mail-table-loading-actions/lib/actions/loadDefaultTable';
import type { MailboxInfo } from 'owa-client-types';
import type { SessionData } from 'owa-service/lib/types/SessionData';
import getScopedPath from 'owa-url/lib/getScopedPath';

export default function loadInitialMailFolderState(
    mailboxInfo: MailboxInfo,
    sessionData?: SessionData
): void {
    const mailRoot = window.location.pathname.startsWith('/hosted/mail') ? '/hosted/mail' : '/mail';
    const skipDefaultFolderSelection =
        window.location.pathname.replace(/\/$/, '') === `${getScopedPath(mailRoot)}/today`;
    if (!skipDefaultFolderSelection) {
        loadDefaultTable(mailboxInfo, sessionData);
    }
    loadFolderForest(sessionData, skipDefaultFolderSelection);
}
